import {System} from '../../index.js';

/**
 * Creates Hypercube.js audio spatialization systems.
 * @example
 * const systemspatialization = new SystemSpatialization();
 *
 * // called by an update loop
 * systemspatialization.tick(timeframe);
 */
class SystemSpatialization extends System {

    /**
     * The audio context.
     * @type {AudioContext}
     * @private
     */
    $context;

    /**
     * The audio listener representing the person listening to the spatial audio.
     * @type {AudioListener}
     * @private
     */
    $listener;

    // @TODO
    $map;

    /**
     * The common PannerNode options used by the system.
     * @type {PannerOptions}
     * @private
     */
    $panneroptions = {

        'channelCount': undefined,
        'channelCountMode': undefined,
        'channelInterpretation': undefined,
        'coneInnerAngle': 360,
        'coneOuterAngle': 360,
        'coneOuterGain': 0.0,
        'distanceModel': 'linear', // @TODO : only for LD53
        'maxDistance': 32, // @TODO : only for LD53
        'orientationX': 0.0,
        'orientationY': 1.0,
        'orientationZ': 0.0,
        'panningModel': 'HRTF',
        'positionX': 0,
        'positionY': 0,
        'positionZ': 0,
        'refDistance': 4,
        'rolloffFactor': 2
    };

    /**
     * Creates a new Hypercube.js audio spatialization system.
     */
    constructor() {

        super();

        this.$map = [];
    }

    /**
     * Destroys the system.
     * @public
     */
    destroy() {

        this.$context.close();
    }

    /**
     * Starts the system.
     * @public
     */
    start() {

        this.$context = new window.AudioContext();
        this.$listener = this.$context.listener;

        // @TODO : faire pareil au tick() pour vérifier l'existance et créer un panner lorsqu'une nouvelle entité est créée !!!
        this.scene.getnodeswithaudio(this.scene.noderoot).forEach(($current) => {

            const [x, y, z] = $current.translation;

            const panner = new PannerNode(this.$context, this.$panneroptions);

            panner.setPosition(x, y, z);

            const audio = $current.audio;
            const track = this.$context.createMediaElementSource(audio);

            track.connect(panner).connect(this.$context.destination);

            this.$map.push({

                'entity': $current,
                'panner': panner,
                'track': track
            });
        });
    }

    /**
     * Updates the system once.
     * @param {number} $timeframe The timeframe duration (in ms).
     * @public
     */
    tick($timeframe) {

        const nodes = this.scene.getnodeswithaudio(this.scene.noderoot);

        nodes.forEach(($current) => {

            let pair = this.$map.find(($pair) => {

                return $pair.entity === $current;
            });

            if (typeof pair === 'undefined') {

                // @TODO : signifie que l'entité est nouvelle est n'a pas encore de panner de créé

                console.log('here');

                const [x, y, z] = $current.translation;

                const panner = new PannerNode(this.$context, this.$panneroptions);

                panner.setPosition(x, y, z);

                const audio = $current.audio;
                const track = this.$context.createMediaElementSource(audio);

                track.connect(panner).connect(this.$context.destination);

                pair = {

                    'entity': $current,
                    'panner': panner,
                    'track': track
                };

                this.$map.push(pair);

                return;
            }

            const [x, y, z] = $current.translation;

            pair.panner.setPosition(x, y, z);
        });

        // @HERE : on clean les anciennes pairs (entities qui ne sont plus dans le node graph)
        this.$map = this.$map.filter(($pair, $index) => {

            const {entity, panner, track} = $pair;

            if (nodes.indexOf(entity) === -1) {

                track.disconnect();
                // panner.disconnect();

                return false;
            }

            return true;
        });

        // console.log(this.$map)

        const [translationx, translationy, translationz] = this.scene.nodecamera.translation;

        const cameramatrix = this.scene.nodecamera.matrix;

        const orientationx = cameramatrix[2];
        const orientationy = cameramatrix[6];
        const orientationz = - cameramatrix[10];

        const upx = 0;
        const upy = 1;
        const upz = 0;

        this.$listener.setPosition(translationx, translationy, translationz);
        this.$listener.setOrientation(orientationx, orientationy, orientationz, upx, upy, upz);
    }
}

export {

    SystemSpatialization
};

export default SystemSpatialization;
